import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesFieldDeleteRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-field-delete',
	path: '/secure/admin/ViewDeleteFieldScreen.jspa',
};
